import { useCallback, useState } from "react";
import { useClientTranslations } from "../../lib/i18n/client";
import type { LibraryCategory } from "../../services/educationService";
import styles from "./CategoryCard.module.css";

interface CategoryCardProps {
	category: LibraryCategory;
}

export function CategoryCard({ category }: CategoryCardProps) {
	const { t } = useClientTranslations("education");
	const [imgError, setImgError] = useState(false);

	const handleImgError = useCallback(() => setImgError(true), []);

	return (
		<button type="button" className={styles.card}>
			{imgError ? (
				<div className={styles.imageFallback} aria-hidden="true" />
			) : (
				<img
					src={category.thumbnail}
					alt={category.name}
					className={styles.image}
					onError={handleImgError}
				/>
			)}
			<div className={styles.overlay}>
				<span className={styles.name}>{category.name}</span>
				<span className={styles.sources}>
					{t("library.sources", { count: category.sourceCount })}
				</span>
			</div>
		</button>
	);
}
